module.exports = __webpack_public_path__ + "components/weather-icon/static/dayriskshowers-5bc76e0d9d23bdffecac16fd9a7c9426.svg";